import { ArrowDown, ArrowUp } from "@aircall/react-icons";

import { CsatDriverPolarity, CsatDriverProps } from "./CsatDriver.decl";

function PickIcon({ polarity }: { polarity: CsatDriverPolarity }) {
  switch (polarity) {
    case "POSITIVE":
      return <ArrowUp className="size-4 text-primary" />;
    case "NEGATIVE":
      return <ArrowDown className="size-4 text-destructive" />;
    default:
      // Exhaustiveness guard: adding a new polarity fails the typecheck here.
      polarity satisfies never;
      return null;
  }
}

export function CsatDriver({ polarity, label }: CsatDriverProps) {
  return (
    <div
      className="flex items-start gap-1"
      data-test={`csat-driver-${polarity.toLowerCase()}`}
    >
      <PickIcon polarity={polarity} />
      <span className="text-tiny font-normal text-muted-foreground">
        {label}
      </span>
    </div>
  );
}
